import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { UpdatePermissionValidationSchema } from "@/features/permissions/schemas/create.schema";
import { useMutation } from "@tanstack/react-query";

interface UseUpdateClientPermissionProps {
  id: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useUpdateClientPermission = ({ id, onSuccess, onError }: UseUpdateClientPermissionProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateClientPermission'],
    mutationFn: (form: UpdatePermissionValidationSchema) => privateAxios.put(`/client/permissions/${id}`, form),
    onSuccess,
    onError
  });
}

export default useUpdateClientPermission
